import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { FaFileContract, FaTools, FaHandshake } from 'react-icons/fa';

const Section = styled.section`
  padding: 6rem 6%;
  background-color: #f7f7f7;
  
  @media (max-width: 768px) {
    padding: 4rem 6%;
  }
`;

const SectionTitle = styled.h2`
  font-size: 2.5rem;
  margin-bottom: 1rem;
  text-align: center;
  color: #000;
  
  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

const SectionSubtitle = styled.p`
  font-size: 1.1rem;
  color: #555;
  text-align: center;
  max-width: 700px;
  margin: 0 auto 3rem;
`;

const CompanyGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2.5rem;
  margin-top: 2rem;
  
  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
  }
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const CompanyCard = styled(motion.div)`
  background-color: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.05);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  display: flex;
  flex-direction: column;
  height: 100%;
  
  &:hover {
    transform: translateY(-10px);
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  }
`;

const CardIcon = styled.div`
  font-size: 2.5rem;
  color: #000;
  padding: 2rem 0;
  display: flex;
  justify-content: center;
  background-color: #f8f8f8;
`;

const CardContent = styled.div`
  padding: 2rem;
  flex: 1;
`;

const CardTitle = styled.h3`
  font-size: 1.5rem;
  margin-bottom: 1rem;
  color: #000;
  position: relative;
  padding-bottom: 1rem;
  
  &:after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 50px;
    height: 2px;
    background-color: #000;
  }
`;

const AboutImage = styled(motion.div)`
  position: relative;
  margin-top: 5rem;
  width: 100%;
  
  &:before {
    content: '';
    position: absolute;
    top: -20px;
    left: -20px;
    width: 50%;
    height: 100%;
    border: 2px solid #000;
    border-radius: 10px;
    z-index: 0;
  }
  
  img {
    position: relative;
    width: 80%;
    border-radius: 10px;
    z-index: 1;
    margin: 0 auto;
    display: block;
    box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
  }
`;

const Company = () => {
  return (
    <Section id="about">
      <SectionTitle>Company</SectionTitle>
      <SectionSubtitle>
        Legal assessment of all companies activities.
      </SectionSubtitle>
      
      <CompanyGrid>
        <CompanyCard
          whileHover={{ y: -10 }}
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.1 }}
        >
          <CardIcon>
            <FaFileContract />
          </CardIcon>
          <CardContent>
            <CardTitle>Contract Drafting and Legal Framework</CardTitle>
            <p>
              Tailored contract drafting, legal guidance, and compliance services for global startups and tech companies at early stages.
            </p>
          </CardContent>
        </CompanyCard>
        
        <CompanyCard
          whileHover={{ y: -10 }}
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.2 }}
        >
          <CardIcon>
            <FaTools />
          </CardIcon>
          <CardContent>
            <CardTitle>Tech products</CardTitle>
            <p>
              Verify the legality of all internal and external products and their functionalities exposed to the end users.
            </p>
          </CardContent>
        </CompanyCard>
        
        <CompanyCard
          whileHover={{ y: -10 }}
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.3 }}
        >
          <CardIcon>
            <FaHandshake />
          </CardIcon>
          <CardContent>
            <CardTitle>Investments</CardTitle>
            <p>
              Due diligence and negotiations structuring.
            </p>
          </CardContent>
        </CompanyCard>
      </CompanyGrid>
      
      <AboutImage
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.6, delay: 0.4 }}
      >
        <img src="https://images.unsplash.com/photo-1589829085413-56de8ae18c73?ixlib=rb-1.2.1&auto=format&fit=crop&w=1000&q=80" alt="LegalHDM Team" />
      </AboutImage>
    </Section>
  );
};

export default Company; 